interface ConfirmModalFooterProps {
    onCancel: () => void;
    onConfirm: () => void;
    cancelDisabled: boolean;
    confirmDisabled: boolean;
    confirmLabel: string;
    /** Tailwind classes for the confirm button's color (bg/hover/text). */
    confirmColorClassName: string;
    cancelLabel?: string;
}

export function ConfirmModalFooter({
    onCancel,
    onConfirm,
    cancelDisabled,
    confirmDisabled,
    confirmLabel,
    confirmColorClassName,
    cancelLabel = 'Cancel'
}: ConfirmModalFooterProps) {
    return (
        <div className="px-5 py-3 border-t border-gray-200 flex items-center justify-end gap-2">
            <button
                type="button"
                onClick={onCancel}
                disabled={cancelDisabled}
                className="px-4 py-2 rounded-md border border-gray-300 text-gray-700 text-xs font-bold bg-white hover:bg-gray-50 transition-colors disabled:opacity-50"
            >
                {cancelLabel}
            </button>
            <button
                type="button"
                onClick={onConfirm}
                disabled={confirmDisabled}
                className={`px-4 py-2 rounded-md text-xs font-bold transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${confirmColorClassName}`}
            >
                {confirmLabel}
            </button>
        </div>
    );
}
